import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { authorAuthService, Category } from '../services/authorAuth';

export const useInitializeSubmissionPage = (
  setCategories: React.Dispatch<React.SetStateAction<Category[]>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  redirectPath: string
) => {
  const navigate = useNavigate();

  useEffect(() => {
    const initializePage = async () => {
      try {
        const cycleResponse = await authorAuthService.isCycleRunning();
        if (!cycleResponse.isSuccess || !cycleResponse.data) {
          await Swal.fire({
            title: 'No Active Cycle',
            icon: 'warning',
            confirmButtonText: 'Back to Dashboard',
            confirmButtonColor: '#088A61',
            allowOutsideClick: false
          });
          navigate(redirectPath);
          return;
        }

        const categoryResponse = await authorAuthService.getAllCategories(true);
        if (categoryResponse.isSuccess && categoryResponse.data) {
          setCategories(categoryResponse.data);
        }

        setIsLoading(false);
      } catch (error) {
        navigate(redirectPath);
      }
    };

    initializePage();
  }, [navigate, setCategories, setIsLoading, redirectPath]);
};